module.exports = __webpack_public_path__ + "static/media/12UNCTAD2.f82e94cf.jpg";